import { createdCoreTable } from '../components/core-table'
import { coreTableProps } from '../props'
import { MAIN_TABLE } from '../config'

const CoreTable = createdCoreTable()
export function createMainTable() {
  return {
    name: 'MainTable',
    props: coreTableProps,
    render() {
      const coreTableAttribute = {
        props: {
          ...this.$props,
          type: MAIN_TABLE
        },
      }
      return (
        <CoreTable { ...coreTableAttribute } ref="mainTable">
          { this.$slots.default }
        </CoreTable>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/layout/main-table.js